var _jsxFileName = "/codebuild/output/src3324576443/src/bitbucket.org/newyuinc/adc-polaris-web/src/components/utility/RichText/utils.tsx";
import React from 'react';
import { Text } from '@adc/parallax-component-library';
import { Link } from './Link';
import { List, ListItem } from './List';
export function getDefaultTransComponents(onPressLink, customNodes, fontToken) {
  return {
    p: /*#__PURE__*/React.createElement(Text, {
      tag: "p",
      display: "block",
      marginBlockStart: "$4",
      marginBlockEnd: "$4",
      type: fontToken,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 14,
        columnNumber: 8
      }
    }),
    strong: /*#__PURE__*/React.createElement(Text, {
      tag: "strong",
      type: "$bodyBase.strong",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 15,
        columnNumber: 13
      }
    }),
    h1: /*#__PURE__*/React.createElement(Text, {
      tag: "h1",
      type: "$h1.strong",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 16,
        columnNumber: 9
      }
    }),
    h2: /*#__PURE__*/React.createElement(Text, {
      tag: "h2",
      type: "$h2.strong",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 17,
        columnNumber: 9
      }
    }),
    h3: /*#__PURE__*/React.createElement(Text, {
      tag: "h3",
      type: "$h3.strong",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 18,
        columnNumber: 9
      }
    }),
    h4: /*#__PURE__*/React.createElement(Text, {
      tag: "h4",
      type: "$h4.strong",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 19,
        columnNumber: 9
      }
    }),
    a: /*#__PURE__*/React.createElement(Link, {
      onPressLink: onPressLink,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 20,
        columnNumber: 8
      }
    }),
    li: /*#__PURE__*/React.createElement(ListItem, {
      fontToken: fontToken,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 21,
        columnNumber: 9
      }
    }),
    ul: /*#__PURE__*/React.createElement(List, {
      listType: "ul",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 22,
        columnNumber: 9
      }
    }),
    ol: /*#__PURE__*/React.createElement(List, {
      listType: "ol",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 23,
        columnNumber: 9
      }
    }),
    br: /*#__PURE__*/React.createElement("br", {
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 24,
        columnNumber: 9
      }
    }),
    ...customNodes
  };
}